import { FileCheck } from "lucide-react";

export const AuditabilityIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.3193 3.9304C12.2513 4.16354 12.2147 4.41124 12.2147 4.66797C12.2147 5.12821 12.5675 5.5013 13.0026 5.5013H17.7299C18.165 5.5013 18.5178 5.12821 18.5178 4.66797C18.5178 4.41124 18.4812 4.16354 18.4132 3.9304M12.3193 3.9304C12.6168 2.90971 13.5157 2.16797 14.5784 2.16797H16.1541C17.2168 2.16797 18.1157 2.90971 18.4132 3.9304M12.3193 3.9304C11.9246 3.95528 11.5312 3.98496 11.1391 4.01938C9.95088 4.12369 9.06321 5.19379 9.06321 6.45488V8.83464M18.4132 3.9304C18.8078 3.95528 19.2012 3.98496 19.5934 4.01938C20.7816 4.12369 21.6693 5.19379 21.6693 6.45488V18.0013C21.6693 19.382 20.611 20.5013 19.3056 20.5013H16.942M9.06321 8.83464H5.51776C4.86506 8.83464 4.33594 9.39428 4.33594 10.0846V22.5846C4.33594 23.275 4.86506 23.8346 5.51776 23.8346H15.7602C16.4129 23.8346 16.942 23.275 16.942 22.5846V20.5013M9.06321 8.83464H15.7602C16.4129 8.83464 16.942 9.39428 16.942 10.0846V20.5013M8.27533 17.168L9.85109 18.8346L13.0026 14.668"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  // <FileCheck stroke="var(--color-policy-orange)" strokeWidth={1.5} />
);

export default AuditabilityIcon;